import { extractCSSVars } from "@UTILS/helpers";

import colors from "@VIEW/styles/exports/colors.module.scss";

export const COLOR = extractCSSVars<string>(colors, (a: string) => a) as Readonly<Constant.Color>;
